import { useActualIncidentId } from '../commonHooks';
import { useQuery } from '@tanstack/react-query';
import { IncidentRoster } from './incidentRoster.types';
import { incidentRosterKeys } from './incidentRoster.queryKeys';
import axios from 'axios';
import config from '../../../../constants/apiConfig';

export const getIncidentRoster = async (incidentId: string) => {
  const response = await axios<IncidentRoster>(
    config.apiGateway.getRosterForIncident,
    {
      method: 'POST',
      data: {
        incident_id: incidentId,
      },
    }
  );
  return response.data ?? [];
};

export const useIncidentRoster = () => {
  const incidentId = useActualIncidentId();

  return useQuery<IncidentRoster>({
    queryKey: incidentRosterKeys.byIncident(incidentId),
    queryFn: async () => getIncidentRoster(incidentId),
    enabled: !!incidentId,
  });
};
